import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';
import styled, {keyframes, css} from "styled-components";

const pinAnimation = keyframes`
    from {
        transform: translateY(-13px);
    }
    to {
        transform: translateY(15px);
    }
`;
const PinGroup = styled.g<{animated?: boolean;}>`
    ${({animated}) => animated ? css`
        transform: translateY(-13px);
        animation: 1s linear 1s infinite alternate ${pinAnimation};
    ` : ""}
`;

const MaskPinPath = styled.path<{animated?: boolean;}>`
    transform: translateY(-35px);
`;
const CirclesGroup = styled.g<{animated?: boolean;}>`
    ${({animated}) => animated ? css`
        /* when the icon is animated, move the circles down a bit so we make room for the pin's animation (up-down) */
        transform: translateY(19px);
    ` : ""}
`;
const smallCircleAnimation = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;
const SmallCirclePath = styled.path<{animated?: boolean;}>`
    opacity: 0;
    ${({animated}) => animated ? css`
        animation: 1s linear 1s infinite alternate ${smallCircleAnimation};
    ` : ""}
`;

export interface ILocationIconProps extends ISvgIconProps {
    animated?: boolean;
}

export class LocationIcon extends React.Component<ILocationIconProps> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 497 624">
                <mask id="myMask">
                    {/* Everything under a white pixel will be visible */}
                    <rect x="0" y="0" width="641.6" height="607.7" fill="white" />

                    {/* Everything under a black pixel will be invisible */}
                    <MaskPinPath animated={this.props.animated}
                        d="M245.7,11.8c-99.3,0-180,80.7-180,180c0,40.3,14.2,86,43.3,139.4C145.4,398,197.8,464,233.2,517.1
                        c4.6,6.9,13.9,8.8,20.8,4.2c1.6-1.1,3.1-2.5,4.2-4.2c35.5-53.2,87.8-119,124.2-185.9c29.1-53.5,43.3-99.1,43.3-139.4
                        C425.7,92.5,345,11.8,245.7,11.8z"
                        fill="black"
                    />
                </mask>

                <CirclesGroup className="circles-group" animated={this.props.animated}>
                    <path mask="url(#myMask)" className="big-circle" fill="currentColor" d="M245.7,605.7c-59.5,0-115.6-8.3-158-23.3c-21.3-7.6-38.3-16.5-50.3-26.6c-14.1-11.8-21.3-25-21.3-39
                        c0-14,7.2-27.2,21.3-39c12-10.1,29-19.1,50.3-26.6c42.4-15,98.5-23.3,158-23.3c59.5,0,115.6,8.3,158,23.3
                        c21.3,7.6,38.3,16.5,50.3,26.6c14.1,11.8,21.3,25,21.3,39c0,14-7.2,27.2-21.3,39c-12,10.1-29,19.1-50.3,26.6
                        C361.3,597.5,305.2,605.7,245.7,605.7z M245.7,451.2c-56.9,0-110.3,7.8-150.3,22c-35.1,12.5-56.1,28.8-56.1,43.7
                        c0,14.9,21,31.2,56.1,43.7c40,14.2,93.3,22,150.3,22c56.9,0,110.3-7.8,150.3-22c35.1-12.5,56.1-28.8,56.1-43.7
                        c0-14.9-21-31.2-56.1-43.7C356,459,302.6,451.2,245.7,451.2z"/>
                    <SmallCirclePath animated={this.props.animated} className="small-circle" fill="currentColor" d="M245.7,558.5c-55,0-113.5-14.6-113.5-41.6c0-27,58.5-41.6,113.5-41.6c55,0,113.5,14.6,113.5,41.6
                        C359.2,543.9,300.7,558.5,245.7,558.5z M245.7,486.4c-28.2,0-54.7,3.6-74.6,10.3c-17.1,5.7-27.8,13.5-27.8,20.2
                        c0,12.7,38.9,30.5,102.4,30.5c28.2,0,54.7-3.6,74.6-10.3c17.1-5.7,27.8-13.5,27.8-20.2C348,504.1,309.1,486.4,245.7,486.4z"/>
                </CirclesGroup>
                <PinGroup animated={this.props.animated}>
                    <path className="" fill="currentColor" d="M245.7,11.8c-99.3,0-180,80.7-180,180c0,40.3,14.2,86,43.3,139.4C145.4,398,197.8,464,233.2,517.1
                        c4.6,6.9,13.9,8.8,20.8,4.2c1.6-1.1,3.1-2.5,4.2-4.2c35.5-53.2,87.8-119,124.2-185.9c29.1-53.5,43.3-99.1,43.3-139.4
                        C425.7,92.5,345,11.8,245.7,11.8z M356.1,316.9c-31.4,57.6-76.2,116.1-110.4,165.3c-34.1-49.2-79-107.6-110.4-165.3
                        c-26.7-49-39.6-89.9-39.6-125.1c0-82.7,67.3-150,150-150s150,67.3,150,150C395.7,227,382.8,267.9,356.1,316.9z"/>
                    <path className="" fill="currentColor" d="M245.7,101.8c-49.7,0-90,40.3-90,90c0.1,49.7,40.3,89.9,90,90c49.7,0,90-40.3,90-90S295.5,101.8,245.7,101.8z
                        M245.7,251.8c-33.1,0-60-26.9-60-60s26.9-60,60-60s60,26.9,60,60S278.9,251.8,245.7,251.8z"/>
                </PinGroup>
            </SvgIcon>
        );
    }
}
